/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect, useRef} from 'react'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {
  getUserByToken,
  register,
  getAydinlatmaMetni,
  getRegisterDates,
  getCustomCountries,
} from '../core/_requests'
import {useAuth} from '../core/Auth'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import {useIntl} from 'react-intl'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useLang} from '../../../../_metronic/i18n/Metronici18n'
import swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {getGuideLink} from '../../../pages/code/list/core/_requests'

const initialValues = {
  firstname: '',
  lastname: '',
  email: '',
  countryId: '',
  password: '',
  changepassword: '',
  acceptTerms: false,
  accepGuide: false,
}

export function Registration() {
  const [modalVisible, setModalVisible] = useState(false)
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [guideAccepted, setGuideAccepted] = useState(false)
  const [guideLinkClick, setguideLinkClick] = useState(false)
  const [countrys, setcountrys] = useState([])
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const AuthError = useIntl().formatMessage({id: 'AUTH.VALIDATION.INVALID_REGISTER'})

  const [aydinlatmaMetni, setAydinlatmaMetni] = useState<Array<any>>()
  const intl = useIntl()
  const registrationSchema = Yup.object().shape({
    firstname: Yup.string()
      // .min(3, useIntl().formatMessage({ id: 'Minimum_3_symbols' }))
      // .max(50, useIntl().formatMessage({ id: 'Maksimum_50_symbols' }))
      .required(useIntl().formatMessage({id: 'First_name_is_required'})),
    email: Yup.string()
      .email(useIntl().formatMessage({id: 'Wrong_email_format'}))
      .min(3, useIntl().formatMessage({id: 'Minimum_3_symbols'}))
      .max(50, useIntl().formatMessage({id: 'Maksimum_50_symbols'}))
      .matches(
        /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
        useIntl().formatMessage({id: 'Email_must_be_lowercase'})
      )
      .required(useIntl().formatMessage({id: 'Email_is_required'})),
    countryId: Yup.number().required(intl.formatMessage({id: 'countryId is required'})),
    lastname: Yup.string()
      // .min(3, useIntl().formatMessage({ id: 'Minimum_3_symbols' }))
      // .max(50, useIntl().formatMessage({ id: 'Maksimum_50_symbols' }))
      .required(useIntl().formatMessage({id: 'Last_name_is_required'})),
    password: Yup.string()
      .min(3, useIntl().formatMessage({id: 'Minimum_3_symbols'}))
      .max(50, useIntl().formatMessage({id: 'Maksimum_50_symbols'}))
      .required(useIntl().formatMessage({id: 'Password_is_required'})),
    changepassword: Yup.string()
      .required('Password confirmation is required')
      .when('password', {
        is: (val: string) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref('password')],
          "Password and Confirm Password didn't match"
        ),
      }),
    acceptTerms: Yup.bool().required(
      useIntl().formatMessage({id: 'You must accept the terms and conditions'})
    ),
    accepGuide: Yup.bool().required(
      useIntl().formatMessage({id: 'You must acknowledge that you have read the user guide'})
    ),
  })
  const navigate = useNavigate()
  const modalRef = useRef<HTMLDivElement | null>(null)
  const lang = useLang()
  const handleAccept = () => {
    setModalVisible(false)
    setTermsAccepted(true)
  }

  const handleCheck = (e: any) => {
    if (!termsAccepted) {
      e.preventDefault()
      setModalVisible(true)
    }
  }

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    if (modalRef.current) {
      const bottom =
        Math.abs(
          e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.clientHeight
        ) < 15
      if (bottom) {
        setButtonDisabled(false)
      }
    }
  }

  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const [link, setLink]: any = useState(null)
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await register(
          values.email,
          values.firstname,
          values.lastname,
          values.password,
          values.countryId
        )
        swal
          .fire({
            title: intl.formatMessage({
              id: 'Success',
            }),
            text: intl.formatMessage({
              id: 'An email confirmation has been sent to your provided email address. Please check your inbox and click on the link provided to proceed with your registration.',
            }),
            icon: 'success',
            confirmButtonText: intl.formatMessage({id: 'Okay'}),
          })
          .then((result) => {
            if (result.isConfirmed) {
              navigate('/auth/login')
            }
          })
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus(AuthError)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
    getGuideLink().then((res: any) => {
      setLink(res)
    })
  }, [])

  useEffect(() => {
    // getRegisterDates().then((a: any) => {

    //   if (a.data?.data?.length === 0 || a.data?.data?.length === undefined) {
    //     navigate('/auth/registerpassive')
    //   }
    // })

    getRegisterDates().then((a: any) => {
      if (a.data === false) {
        navigate('/auth/registerpassive')
      }
    })

    getAydinlatmaMetni().then((a: any) => {
      setAydinlatmaMetni(a.data.data)
    })

    getCustomCountries().then((res: any) => {
      setcountrys(res.data || [])
    })
  }, [])

  const IsGuideAccepted = () => {
    if (guideLinkClick) {
      setGuideAccepted(!guideAccepted)
    }
  }

  const CountryWarning = (value: any) => {
    const country: any = countrys?.find((item: any) => item?.id == value)

    if (country) {
      if (lang === 'tr') {
        swal
          .fire({
            title: intl.formatMessage({id: 'Seçiminizi Onaylıyor musunuz?'}),
            text: intl.formatMessage({id: ` Seçilen Ülke : ${country?.name}`}),
            icon: 'warning', // İkonu 'warning' olarak değiştirdim, onay kutuları için daha uygun
            showCancelButton: true,
            confirmButtonText: intl.formatMessage({id: 'Yes'}),
            cancelButtonText: intl.formatMessage({id: 'No'}),
            allowOutsideClick: false, // Modal dışına tıklayarak çıkışı engelle
            allowEscapeKey: false, // ESC tuşu ile çıkışı engelle
          })
          .then((result) => {
            if (result.isConfirmed) {
              // Evet butonuna tıklandığında yapılacak işlemler

              formik.setFieldValue('countryId', value)
            } else if (result.dismiss === swal.DismissReason.cancel) {
              // Hayır butonuna tıklandığında yapılacak işlemler

              formik.setFieldValue('countryId', ' ')
            }
          })
      } else {
        swal
          .fire({
            title: intl.formatMessage({id: 'Do You Confirm Your Choice?'}),
            text: intl.formatMessage({id: `Selected country : ${country?.nameEn}`}),
            icon: 'warning', // İkonu 'warning' olarak değiştirdim, onay kutuları için daha uygun
            showCancelButton: true,
            confirmButtonText: intl.formatMessage({id: 'Yes'}),
            cancelButtonText: intl.formatMessage({id: 'No'}),
            allowOutsideClick: false, // Modal dışına tıklayarak çıkışı engelle
            allowEscapeKey: false, // ESC tuşu ile çıkışı engelle
          })
          .then((result) => {
            if (result.isConfirmed) {
              // Evet butonuna tıklandığında yapılacak işlemler

              formik.setFieldValue('countryId', value)
            } else if (result.dismiss === swal.DismissReason.cancel) {
              // Hayır butonuna tıklandığında yapılacak işlemler

              formik.setFieldValue('countryId', ' ')
            }
          })
      }
    } else {
      formik.setFieldValue('countryId', ' ')
    }
  }

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='mb-10 text-center'>
        {/* begin::Title */}
        <h1 className='text-dark mb-3'>{useIntl().formatMessage({id: 'Create New Account'})}</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-400 fw-bold fs-4'>
          {/* {useIntl().formatMessage({ id: 'Already have an account?' })} */}
          <Link
            to='/auth/forgot-password'
            className='link-primary fw-bolder'
            style={{marginLeft: '5px'}}
          >
            {useIntl().formatMessage({id: 'Forgot Password ?'})}
          </Link>
        </div>
        {/* end::Link */}
      </div>
      {/* end::Heading */}

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group Firstname */}
      <div className='row fv-row mb-7'>
        <div className='col-xl-6'>
          <div className='fv-row mb-5'>
            <label className='form-label fw-bolder text-dark fs-6'>
              {useIntl().formatMessage({id: 'First name'})}
            </label>
            <input
              placeholder={useIntl().formatMessage({id: 'First name'})}
              type='text'
              autoComplete='off'
              {...formik.getFieldProps('firstname')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.firstname && formik.errors.firstname,
                },
                {
                  'is-valid': formik.touched.firstname && !formik.errors.firstname,
                }
              )}
            />
            {formik.touched.firstname && formik.errors.firstname && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.firstname}</span>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='col-xl-6'>
          {/* begin::Form group Lastname */}
          <div className='fv-row mb-5'>
            <label className='form-label fw-bolder text-dark fs-6'>
              {useIntl().formatMessage({id: 'Last name'})}
            </label>
            <input
              placeholder={useIntl().formatMessage({id: 'Last name'})}
              type='text'
              autoComplete='off'
              {...formik.getFieldProps('lastname')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.lastname && formik.errors.lastname,
                },
                {
                  'is-valid': formik.touched.lastname && !formik.errors.lastname,
                }
              )}
            />
            {formik.touched.lastname && formik.errors.lastname && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.lastname}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}
        </div>
      </div>
      {/* end::Form group */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>
          {useIntl().formatMessage({id: 'Nationality'})}
        </label>
        <select
          className='form-select form-select-solid form-select-lg'
          {...formik.getFieldProps('countryId')}
          value={formik.values.countryId}
          onChange={(e: any) => CountryWarning(e.target.value)}
        >
          <option value=''>{intl.formatMessage({id: 'SEÇİNİZ'})}</option>
          {countrys.map((myval: any) => (
            <option value={myval.id} key={myval?.id as any}>
              {lang === 'tr' ? (myval?.name as any) : (myval?.nameEn as any)}
            </option>
          ))}
        </select>
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
        <div className='alert alert-danger mt-5'>
          {intl.formatMessage({id: 'nationalityWarning'})}
        </div>
      </div>

      {/* begin::Form group Email */}
      <div className='fv-row mb-7'>
        <label className='form-label fw-bolder text-dark fs-6'>
          {useIntl().formatMessage({id: 'Email'})}
        </label>
        <input
          placeholder={useIntl().formatMessage({id: 'Email'})}
          type='email'
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Password */}
      <div className='mb-10 fv-row' data-kt-password-meter='true'>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>
            {useIntl().formatMessage({id: 'Password'})}
          </label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              placeholder={useIntl().formatMessage({id: 'Password'})}
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* begin::Meter */}
          <div
            className='d-flex align-items-center mb-3'
            data-kt-password-meter-control='highlight'
          >
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
          </div>
          {/* end::Meter */}
        </div>
        <div className='text-muted'>
          {useIntl().formatMessage({
            id: 'Use 8 or more characters with a mix of letters, numbers & symbols.',
          })}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Confirm password */}
      <div className='fv-row mb-5'>
        <label className='form-label fw-bolder text-dark fs-6'>
          {useIntl().formatMessage({id: 'Confirm Password'})}
        </label>
        <input
          type='password'
          placeholder={useIntl().formatMessage({id: 'Confirm Password'})}
          autoComplete='off'
          {...formik.getFieldProps('changepassword')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
            },
            {
              'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
            }
          )}
        />
        {formik.touched.changepassword && formik.errors.changepassword && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{intl.formatMessage({id: formik.errors.changepassword})}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-3 mt-3'>
        <div className='d-flex align-items-center'>
          <Form.Check.Input
            className='m-2'
            style={{width: '23px !important', height: '23px !important'}}
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
            checked={termsAccepted}
            onChange={handleCheck}
          />
          <Form.Check.Label htmlFor='kt_login_toc_agree' className='mb-0'>
            {intl.formatMessage({id: 'I Agree the'})}
            {','}
            <br></br>
            <span className='ms-1 link-primary' onClick={() => setModalVisible(true)}>
              {intl.formatMessage({id: 'terms and conditions'})}
            </span>
            .
          </Form.Check.Label>
        </div>
        {formik.touched.acceptTerms && formik.errors.acceptTerms && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.acceptTerms}</span>
            </div>
          </div>
        )}

        <Modal show={modalVisible} onHide={() => setModalVisible(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{intl.formatMessage({id: 'terms and conditions'})}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{overflowY: 'scroll', maxHeight: '400px'}}
              onScroll={handleScroll}
              ref={modalRef}
            >
              {aydinlatmaMetni?.map((myval: any) => (
                <span
                  dangerouslySetInnerHTML={{__html: lang === 'tr' ? myval.text : myval.textEn}}
                />
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => setModalVisible(false)}>
              {intl.formatMessage({id: 'Close'})}
            </Button>
            <Button variant='primary' disabled={buttonDisabled} onClick={handleAccept}>
              {intl.formatMessage({id: 'Accept'})}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div className='fv-row mb-10 '>
        <div className='d-flex align-items-center'>
          <Form.Check.Input
            className='mx-2'
            style={{width: '23px !important', height: '23px !important'}}
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('accepGuide')}
            checked={guideAccepted}
            onChange={(e: any) => IsGuideAccepted()}
          />
          <Form.Check.Label htmlFor='kt_login_toc_agree' className='mb-0'>
            {intl.formatMessage({id: 'YÖS_Kilavuzu_accepted'})}
            {','}
            <br></br>
            <a
              href={`${link?.linkPath}`}
              onClick={(e: any) => setguideLinkClick(true)}
              target='_blank'
              className='ms-1 link-primary'
            >
              {intl.formatMessage({id: 'YÖS_Kilavuzu'})}
            </a>
            .
          </Form.Check.Label>
        </div>
        {formik.touched.accepGuide && formik.errors.accepGuide && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.accepGuide}</span>
            </div>
          </div>
        )}
      </div>

      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid || !termsAccepted || !guideAccepted}
        >
          {!loading && (
            <span className='indicator-label'>{intl.formatMessage({id: 'Submit'})}</span>
          )}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'Please_wait'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100 mb-5'
          >
            {useIntl().formatMessage({id: 'Cancel'})}
          </button>
        </Link>
      </div>
      {/* end::Form group */}
    </form>
  )
}
